/*
 * This file is part of the Neos.Neos.Ui package.
 *
 * (c) Contributors of the Neos Project - www.neos.io
 *
 * This package is Open Source Software. For the full copyright and license
 * information, please view the LICENSE file which was distributed with this
 * source code.
 */
export type {I18nRegistry} from './I18nRegistry';
export {i18nRegistry} from './I18nRegistry';

export type {LegacyParameters} from './LegacyParameters';

export {substitutePlaceholders} from './substitutePlaceholders';
